import { WidgetInputConditional } from '../input/WidgetInputConditional';
import { IWidget } from '../Widget';

/**
 * Widget grafici (di descrizione)
 */
export interface IWidgetGraphic {
  id: number;
  widgetId: number;
  widget: IWidget;

  type: WidgetGraphicType;

  content?: string | null;
  /** per Info (Titolo del box (opzionale), il content è usato per la descrizione ) */
  title?: string | null;
  /** per Section (con o senza bordo , il content è usato per il titolo) */
  bordered: boolean;

  conditional: WidgetInputConditional;
}

export enum WidgetGraphicType {
  /** Testo libero */
  Text = 'GraphicText',
  /** Titolo sezione */
  Section = 'GraphicSection',
  /** Nota informativa */
  Info = 'GraphicInfo',
  /** Divisore */
  Divider = 'GraphicDivider'
}
